import { FilterSection } from "@flights/search-ui";
import React from "react";
import { Stack, Tab } from "@bookingcom/bui-react";
import { useFlightTimesFilterController } from "./useFlightTimesFilter.controller.js";
import { OptionsList } from "./OptionsList.js";
import kebabCase from "lodash/kebabCase";
import { useTrackLayoverPriceAirportFilterWeb } from "../../../../../utils/experiments/funnel/flights_funnel_layover_price_airport_filter_web.js";
import { t, useI18n } from "@bookingcom/lingojs-react";
export const FlightTimesFilterMobile = () => {
    const { isFilterAvailable, title, showReset, resetLabel, onClickReset, moreLabel, options, currentBound } = useFlightTimesFilterController();
    const trackLayoverPriceAirportFilterWeb = useTrackLayoverPriceAirportFilterWeb();
    const i18n = useI18n();
    if (!isFilterAvailable)
        return null;
    return (React.createElement(FilterSection, { attributes: { "data-testid": "flight_times_filter" }, title: {
            text: title,
            tagName: "h3",
            attributes: { id: "flight_times_filter" },
            variant: trackLayoverPriceAirportFilterWeb() ? "strong_2" : "emphasized_1"
        }, reset: showReset
            ? {
                text: resetLabel,
                onClick: onClickReset,
                attributes: {
                    "data-testid": "search_filter_flight_times_reset",
                    "aria-label": i18n.trans(t("a11y_flights_filter_reset_times"))
                }
            }
            : undefined }, !!currentBound ? (React.createElement(OptionsList, { optionIndex: currentBound === "outbound" ? 0 : 1 })) : options.length === 1 ? (React.createElement(OptionsList, { optionIndex: 0 })) : (React.createElement(Tab, { vertical: false, moreLabel: moreLabel, fillEqually: true },
        React.createElement(Stack, null,
            React.createElement(Tab.TriggerList, null, options.map(({ labels }, i) => {
                return (React.createElement(Tab.Trigger, { id: kebabCase(labels.title), text: labels.title, key: labels.title + i, linkAttributes: { "data-testid": `flight_times_filter_v2_flight_times_button_${i}` } }));
            })),
            options.map(({ labels }, optionIndex) => {
                return (React.createElement(Tab.Panel, { key: labels.title + optionIndex, id: kebabCase(labels.title) },
                    React.createElement(OptionsList, { optionIndex: optionIndex })));
            }))))));
};
